import React from 'react';
import {
  H5MigrationMode,
  getH5MigrationExternalGuideUrl,
  getH5MigrationMode,
} from '@/utils/h5-migration';

export function useH5MigrationGuard() {
  const [mode, setMode] = React.useState<H5MigrationMode>(() => {
    if (typeof window === 'undefined') {
      return 'disabled';
    }
    return getH5MigrationMode(window.location.pathname);
  });

  React.useLayoutEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const nextMode = getH5MigrationMode(window.location.pathname);
    setMode(nextMode);

    if (nextMode === 'guide') {
      const url = getH5MigrationExternalGuideUrl();
      if (url) {
        window.location.replace(url);
      }
    }
  }, []);

  return mode;
}
